<template>
  <b-nav-item
    :id="`navItem-${option.id}`"
    href="javascript:;"
    class="option-nav"
    :active="isActive"
    @click="$emit('input', option)"
  >
    <div class="icon-box">
      <div
        class="icon-wrapper"
        :class="{ locked: isDefaultOption, 'no-lock': noLock }"
      >
        <fa-icon
          v-if="icon"
          fixed-width
          :icon="icon"
        />
        <i
          v-if="alticon"
          :class="alticon"
          aria-hidden="true"
        />
        <i
          v-if="!icon && !alticon"
          class="submenu-icon far fa-circle"
          aria-hidden="true"
        />
      </div>
      <div
        v-if="!noLock"
        @click.stop
      >
        <vt-lock-toggle
          :id="`lockToggle-${option.id}`"
          class="option-nav-lock"
          :class="{ locked: isDefaultOption }"
          :value="isDefaultOption"
          @input="setDefaultOption"
        />
      </div>
    </div>

    <slot>
      <span
        v-if="label"
        class="option-label"
      >{{ label }}</span>
    </slot>

    <slot name="after-label" />
  </b-nav-item>
</template>

<script>

export default {
    name: 'OptionNav',
    props: {
        option: { type: Object, required: true },
        defaultOption: { type: Object, default: null },
        value: { type: Object, default: null },
        label: { type: String },
        noLock: { type: Boolean, default: false },
        store: { type: Object },
        classLink: { type: String },
        icon: { type: Array },
        alticon: { type: String }
    },
    computed: {
        isActive() {
            if (this.value && this.value.id) {
                return this.value.id === this.option.id
            } else if (this.value && this.value.operation) {
                return this.value.operation === this.option.operation
            }
            return false
        },
        isDefaultOption() {
            if (this.store) {
                return this.store.state.config.defaultOptionId === this.option.id
            }
            return this.defaultOption?.id === this.option.id
        }
    },
    methods: {
        async setDefaultOption() {
            let defaultOption = null
            if (!this.isDefaultOption) {
                defaultOption = this.option
            }
            this.$emit('setDefaultOption', defaultOption)

            if (this.store) {
                this.store.setDefaultOption(defaultOption)
                await this.store.saveConfig()
            }
        }
    }
}

</script>

<style scoped lang="scss">

.icon-box {
    width: 32px;
    height: 32px;
    margin-right: 7px;
}

.option-nav-lock {
  display: none !important;
  &.locked {
    display: block !important;
  }
}

.icon-wrapper {
  display: block;
  &.locked {
    display: none;
  }
}

.icon-wrapper {
  font-size: 1rem;
  margin-right: 7px;
  width: 32px;
  color: vt-color(sidebar-parent-icon);
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  > .svg-inline--fa {
    margin-left: unset !important;
  }
}

.no-lock {
    display: flex !important;
    text-align: center;
}

.option-nav:hover .icon-wrapper {
    display: none;
}

.option-nav:hover .option-nav-lock {
  display: block !important;
}

.submenu-icon {
    font-size: 0.7rem;
}

.option-nav .nav-link .icon-box {
    align-self: flex-start;
}

.option-nav .nav-link .badge {
    align-self: flex-start;
    margin-left: auto !important;
    margin-top: 10px;
}

.option-nav .nav-link span:nth-child(2) {
   margin: 5px 0;
   margin-right: 5px;
}

@media (max-width: 1300px){
    .icon-wrapper{
        font-size: 1.1rem;
    }
}

</style>
